import angular from 'angular';
import uiRouter from 'angular-ui-router';

import memberComplianceService from './member-compliance.service';

export default
  angular.module('components.admin.member-compliance-process', [
    uiRouter
  ])
    .service('MemberComplianceService', memberComplianceService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('memberComplianceProcess', {
          parent: 'admin',
          abstract: true,
          resolve: {
            processed: MemberComplianceService => MemberComplianceService.process().then(() => true)
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance-process.module.js